/**
 * AskPenneyHeaderButton.jsx
 * Header bar trigger button for Ask Penney chat
 * Figma: Constructor ASA Design SSUX-5980 - "Ask Penney" button in header
 *
 * Exact Figma specs:
 * - Size: 149px x 40px
 * - Background: white (#FFFFFF)
 * - Border: 2px solid #E71324 (brand red)
 * - Border radius: 40px (pill shape)
 * - Text: #202020 (grayscale black)
 * - "Ask": Open Sans Bold, 14px
 * - "Penney": Open Sans ExtraBold, 14px
 * - "BETA": Open Sans SemiBold, 8px, positioned top-right above "Penney"
 * - Sparkles icon: 16x16px, red
 */
import React from 'react';
import PropTypes from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { SparklesIcon } from './AskPenneyIcons';

/**
 * Header button for Ask Penney - appears in the header bar (not floating).
 * Opens the ShoppingAssistant chat panel when clicked.
 */
const AskPenneyHeaderButton = ({ onClick, className }) => {
    return (
        <button
            className={`${dt([
                'flex',
                'items-center',
                'justify-center',
                'h-10',
                'px-5',
                'bg-white',
                'rounded-full',
                'cursor-pointer',
                'transition-all',
                'duration-200',
                'whitespace-nowrap',
                'hover:bg-red-50',
                'hover:shadow-sm',
                'focus:outline-2',
                'focus:outline-brand-red',
                'focus:outline-offset-2',
                'active:scale-[0.98]',
            ])} ${className || ''}`}
            style={{
                border: '2px solid #E71324',
            }}
            onClick={onClick}
            aria-label="Open Ask Penney AI shopping assistant"
            type="button"
            data-automation-id="askPenneyHeaderButton"
        >
            <div className={dt(['flex', 'items-center', 'gap-1'])}>
                {/* AskPenney text with BETA above per Figma - no space between Ask and Penney */}
                <div className={dt(['relative', 'flex', 'items-center'])}>
                    {/* BETA badge - 8px SemiBold, positioned top-right */}
                    <span
                        className={dt(['absolute', 'font-semibold'])}
                        style={{
                            color: '#202020',
                            fontSize: '8px',
                            lineHeight: '1',
                            top: '0px',
                            left: '73%',
                        }}
                    >
                        BETA
                    </span>
                    {/* "AskPenney" - no space, "Ask" 700, "Penney" 800 */}
                    <span
                        className={dt(['text-sm', 'leading-6'])}
                        style={{ color: '#202020', fontWeight: 700 }}
                    >
                        Ask
                    </span>
                    <span
                        className={dt(['text-sm', 'leading-6'])}
                        style={{ color: '#202020', fontWeight: 800 }}
                    >
                        Penney
                    </span>
                </div>
                {/* Sparkles icon - 16x16px per Figma */}
                <SparklesIcon className={dt(['flex-shrink-0'])} size={16} />
            </div>
        </button>
    );
};
AskPenneyHeaderButton.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
};
AskPenneyHeaderButton.defaultProps = {
    onClick: undefined,
    className: '',
};
export default AskPenneyHeaderButton;
